import styled from "styled-components/macro";
import { TextField } from "@mui/material";

export const FormGroup = styled.div`
  margin-bottom: ${(props) => (props.mb ? props.mb : "1rem")};
`;

export const TextInput = styled(TextField)`
  display: block !important;
  /* padding: 0.375rem 0.75rem !important; */
  font-size: 1rem;
  line-height: 1.5;
  color: ${(props) => props.textcolor};
  background: ${(props) => props.bg};
  background-clip: padding-box;
  border: ${(props) => props.border}
  // border-radius: 10px !important;
  
  .MuiInput-underline:before {
    border-bottom: none !important;
  }
  .MuiInput-underline:after {
    border-bottom: none !important;
  }
  .MuiInputBase-root {
    width: 100%;
  }
  .MuiInputBase-root {
    // font-weight: 500 !important;
  }
  .MuiInput-underline {
    &:before {
      position: relative !important;
    }
  }
  /*.MuiInputBase-root-MuiOutlinedInput-root{
    color: unset;
  } */
  .MuiOutlinedInput-notchedOutline{
    border:${(props) => (props.border ? props.border : "unset")};
  }

  .Mui-disabled{
    color: ${(props) => props.textcolor};
  }

  .MuiOutlinedInput-input{
    color: ${(props) => props.textcolor};
    font-size: ${(props) => (props.size ? props.size : "1rem")};
    font-weight: ${(props) => props.bold};
    border-radius: ${(props) => (props.br ? props.br : "10px !important")};
    padding: ${(props) => props.padding}!important;
    text-align: ${(props) => (props.center ? "center" : "left")};
  }
`;
